import { AxiosResponse } from 'axios';

import BaseApi from './BaseApi';

class CountryResidenceApi extends BaseApi {
	constructor() {
		super('/investor/tax/country-residence');
	}

	add(body: any): Promise<AxiosResponse<unknown>> {
		return this.httpClient.post({
			conditions: { auth: true, version: 'v2' },
			url: '/after-verification',
			body,
		});
	}

	uploadDocument(body: any): Promise<AxiosResponse<unknown>> {
		return this.httpClient.post({
			conditions: { auth: true, version: 'v2' },
			url: '/upload-tadt-doc',
			body,
			config: {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			},
		});
	}
}

export const CountryResidenceService = new CountryResidenceApi();
